import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Input } from 'react-toolbox/lib/input';
import Tag from '~/components/Tag';
import Spinner from '~/components/Spinner';
import styleDialog from '~/style/dialog.scss';
import { list2 } from '~/actions/articles';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      more: false,
      results: [],
      query: ''
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query)
      .then(r => this.setState({
        results: r.data.results.map(i => i.id),
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  loadMore() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, this.state.skipId)
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <div>Pick an article</div>
            <form onSubmit={e => { e.preventDefault(); this.search(); }}>
              <Input
                type="text"
                label="Search Name, UPC, SKU or ID"
                value={this.state.query}
                onChange={v => this.setState({ query: v, skipId: null })}
              />
              <Button label="Find" primary raised type="submit" />
            </form>
            <br />
            <div style={{ overflow: 'auto', maxHeight: '50vh' }}>
              {this.state.results.length === 0 && !this.state.loading ? 'No article in stock' : this.state.results.map(articleId => (<div key={articleId}><Tag
                key={articleId}
                id={articleId}
                type="article"
                style={{ margin: '5px 5px 0 0' }}
                onClick={() => {
                  this.props.data.onChange(articleId);
                  this.context.dialogClose(this.props.dialogId);
                }}
              />
              </div>))}
              {(this.state.loading || this.state.more) && <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                {this.state.loading && <Spinner />}
                {!this.state.loading && this.state.more && <Button
                  label="Load more"
                  disabled={this.state.loading}
                  primary
                  raised
                  onClick={() => this.loadMore()}
                />}
              </div>}
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['articles', 'articles']).toJS(),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ArticlePick/index.js